/**
 * Created by daniel on 9/8/15.
 */

/**
 * Displays confirmation popup.
 *
 * data may be an empty array.  For example, changing the status contains status in the URL and no data to pass.
 *
 * @param url
 * @param data
 * @param callback
 */

function affectedConfirm(url, data, callback) {
    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        success: function (data) {
            // error:ERROR_MESSAGE is returned if there is an error
            if (typeof data === 'string' && data.trim().startsWith('error:')) {
                const error = data.trim().replace(/^error:/, '');
                const errorHTML = '<li>' + (error || 'An error occurred before confirmation.') + '</li>';

                $('#dynamicErrors').html(errorHTML);
                $('#dynamicErrorsContainer').show();

                if (window.app?.fns?.forceCloseModal) {
                    window.app.fns.forceCloseModal('#confirmPopup');
                }
                return;
            }

            // Parse HTML safely (Direct jQuery parsing without fake <html> tags)
            const $parsedHtml = $(data);
            const countVal = $parsedHtml.find('#affectedCount').addBack('#affectedCount').val();
            const affectedCount = parseInt(countVal, 10);

            if (isNaN(affectedCount)) {
                $('#dynamicErrors').html('<li>An error occurred before confirmation.</li>');
                $('#dynamicErrorsContainer').show();
                return;
            }

            if (affectedCount <= 0) {
                // There are no affected products/options, thus no confirmation needed.
                // This else bypasses the confirmation and directly runs the operation
                callback();
                return;
            }

            const $confirmPopup = $('#confirmPopup');
            const el = $confirmPopup[0];

            $confirmPopup.empty().append($parsedHtml);

            // Re-bind dynamic click handlers
            $confirmPopup
                .off('click', '#confirm')
                .on('click', '#confirm', function () {
                    callback();
                    window.app.fns.forceCloseModal('#confirmPopup');
                })
                .off('click', '#confirmCancel')
                .on('click', '#confirmCancel', function () {
                    window.app.fns.forceCloseModal('#confirmPopup');
                });

            const addShowClasses = () => {
                $('.modal-backdrop').addClass('in show');
                $confirmPopup.addClass('in show');
            }

            // force visibility classes - legacy Bootstrap 3 markup may not get the BS5 `show` class applied consistently
            el.addEventListener('shown.bs.modal', (e) => {
                if (e && e.target !== el) return; // Ignore events bubbling up from child elements
                addShowClasses()
            }, { once: true });

            // Trigger BS native Display via BS5 or BS3
            if (window.bootstrap?.Modal) {
                const existing = window.bootstrap.Modal.getInstance(el);
                if (existing) existing.dispose();

                const bsModal = new window.bootstrap.Modal(el);
                bsModal.show();
            } else if ($.fn.modal) {
                $confirmPopup.modal('show');
            }

            // Fallback for backdrop classes in case 'shown.bs.modal' is bypassed by CSS
            setTimeout(function () {
                addShowClasses();
            }, 150);
        }
    });
}

/**
 * Runs the desired operations if the confirmation popup is confirmed.
 *
 * data can be empty.
 *
 * @param url
 * @param data
 * @param successCallback
 */
function runConfirmedOperation(url, data, successCallback) {
    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        success: function (data) {
            var response = JSON.parse(data);

            // if there was a successful response, check the status as to whether the operation was successful or not
            var hasResponse = response.hasOwnProperty('status');
            if (hasResponse) {
                if (response.status == 'success')
                    var success = true;
                else
                    var success = false;
            }
            else
                var success = false;

            if (success) {
                successCallback(response);
            }
            else {
                // An error was caught by the php function
                if (hasResponse) {
                    var error = response.message;
                }
                else {
                    // An error occurred that was not caught
                    var error = 'An error occurred after confirmation.';
                }

                var errorHTML = '<li>' + error + '</li>';

                $('#dynamicErrors').html(errorHTML);
                $('#dynamicErrorsContainer').show();
                window.app.fns.forceCloseModal('#confirmPopup');
            }
        }
    });
}

// these two are used in some combinations of
// legacy js module files, script includes, and
// blade file inline scripts that we need attached to window
// rather than scoped to the app.fns object
window.app.fns.affectedConfirm = affectedConfirm;
window.app.fns.runConfirmedOperation = runConfirmedOperation;

export {
    affectedConfirm,
    runConfirmedOperation
}
